import React, { useEffect, useState } from 'react'
import Lottie from 'react-lottie-player'

import cx from 'classnames'

import { YANADOO_CDN_HOST } from 'common/config'
import useChatFeedListStore from 'store/useChatFeedListStore'

import ChatFeedItem from './ChatFeedItem'
import InitMessage from './InitMessage'
import { AINADOO_CONFIG } from '../config'
import s from './styles/Chat.module.scss'

const defaultOptions = {
  loop: true,
  play: true,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
}

export default function ChatFeedList({ isAiResponse, userSeq, pageType }) {
  const { feedList } = useChatFeedListStore()

  const [lottieData, setLottieData] = useState(null)

  useEffect(() => {
    const fetchLottieData = async () => {
      try {
        const response = await fetch(`${YANADOO_CDN_HOST}/lottie/aifaq-loading-spinner-dots.json`)
        const jsonData = await response.json()
        setLottieData(jsonData)
      } catch (error) {
        console.error('Lottie 데이터를 불러오는데 실패했습니다:', error)
      }
    }
    fetchLottieData()
  }, [])

  return (
    <ul className={s.feedList}>
      <InitMessage pageType={pageType} />
      {feedList.map(({ type, message }, index) => (
        <li className={cx(s.feedItem, s[type.toLowerCase()])} key={index}>
          <ChatFeedItem
            type={type}
            message={message}
            isAiResponse={isAiResponse}
            userSeq={userSeq}
            pageType={pageType}
          />
        </li>
      ))}
      {isAiResponse && (
        <li className={cx(s.feedItem, s.srrLoading)}>
          <div className={s.aiMessage}>
            <div className={s.msgThumb}>
              <img
                src={`${AINADOO_CONFIG.IMG_HOST}${
                  pageType === 'srr' ? 'img_ainadoo_profile_srr' : 'img_ainadoo_profile'
                }.png`}
                alt="AI 스르르"
              />
            </div>
            <dl>
              <dt className={s.msgName}>{pageType === 'srr' ? 'AI 스르르' : 'AI 나두'}</dt>
              <dd className={s.message}>
                <div className={s.lottieBox}>
                  <Lottie {...defaultOptions} animationData={lottieData} />
                </div>
                답변을 생성 중입니다.
              </dd>
            </dl>
          </div>
        </li>
      )}
    </ul>
  )
}
